<template>
  <div class="block page18 f-r f-c">
    <PageHeader
      :title="moduleData['3_18_1_1']"
      :sub-title="moduleData['3_18_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page18-body f-r j-b">
      <div class="page18-body-left">
        <div class="page18-body-header f-r j-b a-c">
          <div class="page18-body-header-left">{{ PAGE_TEXT[commonLang].nearbyRestaurants }} {{ total }} {{ PAGE_TEXT[commonLang].unitStore }}</div>
        </div>
        <PieChart style="margin-top: -40px; height: 500px; width: 100%" :chart-data="pieData">
          <Empty :text="PAGE_TEXT[commonLang].noCateringCoverage" v-if="!pieData.length"/>
        </PieChart>
        <div
          v-if="reportCustomization.showWater"
          class="page-tips2 small"
        >{{ PAGE_TEXT[commonLang].moreInfo }}</div>

        <div class="page18-body-header f-r j-b a-c" style="margin-top: 40px; margin-bottom: 10px">
          <div class="page18-body-header-left">{{ PAGE_TEXT[commonLang].categoryDistribution }}</div>
        </div>
        <BarChart style="height: 265px; width: 100%"
                  :show-more="true"
                  :x-data="barData.map(v => v.name)"
                  :y-data="barData.map(v => v.value)">
          <Empty :text="PAGE_TEXT[commonLang].noCateringCoverage" v-if="!barData.length"/>
        </BarChart>
      </div>
      <div class="page18-body-right">
        <div class="page18-body-right f-c">
          <div class="page12-map" id="page12Map">
            <Empty :text="PAGE_TEXT[commonLang].noCateringCoverage" v-if="!typeList.length"/>
          </div>
          <div class="page12-map-legend f-r a-c f-w">
            <div
              :class="['page12-map-legend-item f-r a-c', commonLang !== 'zh' ? 'small' : '']"
              v-for="(item, index) in typeList"
              :key="index"
            >
              <div
                class="page12-map-legend-point point1"
                :style="{ background: item.color }"
              ></div>
              {{ item.name }}
            </div>
          </div>
          <div v-if="reportCustomization.showDataSource" class="page12-map-tips">
            {{ PAGE_TEXT[commonLang].dataSource }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import PieChart from "./components/PieChart2";
import BarChart from "./components/BarChart3";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";

import { getMapDelayByMarkerCount } from '@/utils'
import {
  drawMapKeepAlive,
} from '@/api/apiv2'

const props = defineProps({
    pageNum: String,
    cityInfo: {
        type: Object,
        default: () => {
            return {};
        },
    },
    catData: {
        type: Array,
        default: () => [],
    },
    moduleData: {
      type: Object,
      default: () => {
        return {

        };
      },
    },
    // poi改造后数据
    poiData: {
      type: Object,
      default: () => {},
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    nearbyRestaurants: '周边餐饮门店 共',
    unitStore: '家',
    noCateringCoverage: '当前区域暂无餐饮覆盖',
    moreInfo: '>当前图表中仅展示部分分类，全部餐饮数据于APP「周边配套」中查看',
    categoryDistribution: '区域餐饮品类数量分布（家）',
    dataSource: '数据来源：餐饮外卖平台边界大数据整合'
  },
  'en': {
    nearbyRestaurants: 'Nearby Restaurants Total',
    unitStore: 'stores',
    noCateringCoverage: 'No catering coverage in current area',
    moreInfo: '',
    categoryDistribution: 'Regional Catering Category Quantity Distribution (stores)',
    dataSource: 'Data Source: Catering delivery platform Boundary big data integration'
  }
};

    const store = useStore()
    const color = [
      "#0045FF",
      "#FF7800",
      '#FF0000',
      '#17C49D',
      '#00BEFF',
      '#A933E4',
      '#00FF19',
      '#DACE10',
      '#6694CF',
      '#F53A99',
      '#A1C607',
      '#6005B1',
      '#FF5E87',
    ];

    let map = shallowRef(null);
    const addMaker = (amap, map, data) => {
        let markerList = [];
        const newData = data?.poi || []
        newData.forEach((v) => {
            let content = `<div style="width: 12px;height: 12px; border-radius: 50%;background: ${data.color};"></div>`
            let marker = new amap.Marker({
                position: new amap.LngLat(
                    v.location.split(",")[0],
                    v.location.split(",")[1]
                ),
                content
            });
            markerList.push(marker);
        });
        map.add(markerList);
    };
    onMounted(() => {
        AMapLoader.load({
            key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap) => {
          map = new AMap.Map("page12Map", {
            WebGLParams: {
                preserveDrawingBuffer:true
            },
            dragEnable: false,
            zoomEnable: false,
            zoom: store.getters.mapZoom, //初始化地图级别
            center: props.cityInfo.location.split(","), //初始化地图中心点位置
          });

          // 按数量排序 多的点先绘制 在底层 视觉效果好一点
          const sortList = props.catData.map((c, index) => ({
            ...c,
            color: color[index],
          })).sort((a, b) => b.poi.length - a.poi.length)
          for (let i = 0; i < sortList.length; i++) {
            addMaker(AMap, map, sortList[i]);
          }

          if (props.cityInfo.is_polygon) {
            mapAddPolygonV2(props.cityInfo?.polygon || '', map)
          } else {
            mapAddCircle(props.cityInfo, map);
          }
          addMapCenter(AMap, map, props.cityInfo.location)

          // 等待地图渲染
          const delay = getMapDelayByMarkerCount(sortList.length)
          drawMapKeepAlive(delay).catch((e) => {})

          map.setFitView()
      })
      .catch((e) => {
          console.log(e);
      });
    });

    // poi改版
    const total = computed(() => {
      if (!props.poiData || !props.poiData?.nearby?.length) return 0
      const item = props.poiData.nearby.find((n) => n.bhProType === 'P070000')
      return item?.count || 0
    })

    const typeList = props.catData.map((item, index) => ({
      name: item.bhProTypeName,
      color: color[index],
    }))

    const pieData = computed(() => {
        return props.catData.map((item) => ({
          name: item.bhProTypeName,
          value: item.count,
        }))
    })

    const barData = computed(() => {
        return props.catData.map((item) => ({
          name: item.bhProTypeName,
          value: item.count,
        }))
    })
</script>

<style lang="less">
.page18 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page18-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
    .page18-body-left {
      width: 900px;
      .page18-body-header {
        height: 33px;
        font-size: 24px;

        font-weight: bold;
        color: #333333;
        line-height: 33px;
        margin-bottom: 10px;
      }
    }
    .page18-body-right {
      width: 853px;
      .page12-map {
        width: 100%;
        height: 760px;
      }
      .page12-map-legend {
        flex-grow: 1;

        .page12-map-legend-item {
          width: 20%;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-top: 12px;

          &.small {
            margin-top: 4px;
            font-size: 12px;

            .page12-map-legend-point {
              width: 14px;
              min-width: 14px;
              height: 14px;
            }
          }
        }
        .page12-map-legend-item:last-child {
          margin-right: 0;
        }

        .page12-map-legend-point {
          width: 22px;
          min-width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .point1 {
          background-color: #0045FF ;
        }
      }
      .page12-map-tips {
        flex-shrink: 0;
        text-align: right;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
